<script>
    import { gps_stationary_datapoints, gps_datapoints, projection } from './store.js';
    import { scaleLinear } from 'd3-scale';
    import GeoExample from './GeoExample.svelte';
    
    const scaleCumulativeSeconds = scaleLinear().domain([0,1440]).range([0,600])
    const scaleMouseXToCumulativeSeconds = scaleLinear().domain([0,600]).range([0,1440])
        // const scaleCumulativeSeconds = scaleLinear().domain([0,86400]).range([0,600])
        // const scaleMouseXToCumulativeSeconds = scaleLinear().domain([0,600]).range([0,86400])
    const scaleTicks = scaleLinear().domain([0,24]).range([0,600])

    $: time_grid = scaleTicks.ticks(25)

    let slider_position = 0;
    let car = 1;
    let day = 6;
    let cars = [... new Array(35)].map((d,i) => i+1).concat([101,102,103,104,105,106,107])
    let days = [... new Array(14)].map((d,i) => i+6)

    // let datapoints = []
	// $: {
    //     db.query(aql`
	// 		FOR p IN car_positions
	// 		FILTER p.car_id == ${car}
    //         FILTER p.day == ${day}
	// 		RETURN p
	// 	`).then(
	// 		cursor => cursor.map(doc => doc)
	// 	).then(
	// 		data => datapoints = data
    //     );
    // }
    
    let augmented_stationary_datapoints;
    $: {
        augmented_stationary_datapoints = []
        $gps_stationary_datapoints.forEach(d => {
            d.geo = projection([d.long, d.lat])
            augmented_stationary_datapoints = [...augmented_stationary_datapoints, d]
        })  
    }

    let datapoints = []
    $: datapoints = $gps_datapoints.filter(d => { return d.day == day & d.car_id == car})

    // $: console.log(datapoints)

    let augmented_datapoints
    $: {
        augmented_datapoints = []
        datapoints.forEach(d => {
            d.geo = projection([d.avg_long, d.avg_lat])
            augmented_datapoints = [...augmented_datapoints, d]
        })
    }

    $: visible_datapoints = augmented_datapoints.filter(d => { return Math.abs(slider_position - d.cumulative_minute) < 2 })

    let mouse_x = 0;
	function handleMousemove(event) {
		mouse_x = event.clientX -5;
	}
    $: slider_position = scaleMouseXToCumulativeSeconds(mouse_x)

    const calculateHourString = function(sec) {
        let hour = Math.floor(sec/3600)
        let remaining_sec = sec - hour*3600
        let min = Math.floor(remaining_sec/60)
        return hour + ':' + min
    }

    // $: console.log(gps_datapoints)
</script>

<style>
    svg {
        /* background-color: whitesmoke; */
    }
    circle {
        fill: steelblue;
        /* fill-opacity: 0.7; */
    }
    circle.trace {
        fill: steelblue;
        /* fill-opacity: 1 */
    }
    circle.background {
        fill: rgb(78, 125, 164);
        /* fill-opacity: 0.5; */
    }
    circle.speed {
        /* fill-opacity: 0.8 */
    }
    circle.stationary {
        /* fill-opacity: 0.8; */
        fill: darkred;
    }
    line {
        stroke: red;
    }
    line.grid {
        stroke: black;
        stroke-width: 0.2;
    }
    text.grid {
        font-size:xx-small;
    }
</style>

<h2>CarTrace</h2>
{#if datapoints.length == 0}
Loading data...
{:else}
Day: 
<select bind:value={day}>
    {#each days as day}
        <option value={day}>{day}</option>
    {/each}
</select><br/>
Car: 
<select bind:value={car}>
    {#each cars as car}
        <option value={car}>{car}</option>
    {/each}
</select><br/>
Time of day: {calculateHourString(slider_position)}<br/>
<svg width=600 height=100
    on:mousemove={handleMousemove}>
    {#each time_grid as tick}
        <line class="grid" x1={scaleTicks(tick)} x2={scaleTicks(tick)} y1=0 y2=100 />
        <text class="grid" x={scaleTicks(tick)} y=10>{tick}</text>
    {/each}
    {#each augmented_datapoints as datapoint}
        <circle class="speed" cx={scaleCumulativeSeconds(datapoint.cumulative_minute)} cy={100-datapoint.avg_speed/2} r=2 />
    {/each}
    {#each time_grid as tick}
        <line class="grid" x1={scaleTicks(tick)} x2={scaleTicks(tick)} y1=0 y2=100 />
        <text class="grid" x={scaleTicks(tick)} y=10>{tick}</text>
    {/each}
    <line x1={mouse_x} y1=0 x2={mouse_x} y2=100 />
</svg><br/>

<svg width=1000 height=800>
    <g transform="translate(250,200) scale(0.5)">
        <GeoExample />
        {#each augmented_stationary_datapoints as datapoint}
            <circle class="stationary" cx={datapoint.geo[0]} cy={datapoint.geo[1]} r=3 />
        {/each}
        {#each augmented_datapoints as datapoint}
            <circle class="background" cx={datapoint.geo[0]} cy={datapoint.geo[1]} r=3 />
        {/each}
        {#each visible_datapoints as datapoint}
            <circle class="trace" cx={datapoint.geo[0]} cy={datapoint.geo[1]} r=7 />
        {/each}
    </g>
</svg>
{/if}